import React from 'react';
import _isNaN from 'lodash/isNaN';
import _map from 'lodash/map';
import dayjs from 'dayjs';
import { useStyletron } from 'baseui';

import { ChangesVersionHistory } from 'constant';
import { EMPTY_STRING } from 'commons-ui';

export const REQUIRED_KEYS = {
	BUCKETS: 'buckets',
	START: 'start',
	END: 'end'
};

export const requiredKeysList = Object.values(REQUIRED_KEYS);

export const useDataFormatter = () => {
	const [css] = useStyletron();

	const renderBuckets = (buckets: any) => (
		<ul className={css({ listStyle: 'none' })}>
			{_map(buckets, (bucket: any) => (
				<li>
					NAME : {bucket?.name}, PERCENTAGE : {bucket?.share}
				</li>
			))}
		</ul>
	);

	const renderDate = (date: number) => (
		<div>{date && !_isNaN(date) ? dayjs(new Date(date)).format('MMM D, YYYY h:mm A').toString() : EMPTY_STRING}</div>
	);

	const abTestVersionHistoryFormatter = (data: ChangesVersionHistory) => {
		if (data.key === REQUIRED_KEYS.END || data.key === REQUIRED_KEYS.START) {
			const { oldValue } = data;
			const { newValue } = data;
			const formattedOldTime = renderDate(oldValue);
			const formattedNewTime = renderDate(newValue);

			return {
				...data,
				oldValue: formattedOldTime,
				newValue: formattedNewTime
			};
		}
		if (data.key === REQUIRED_KEYS.BUCKETS) {
			const { oldValue } = data;
			const { newValue } = data;

			const formattedOldBucket = renderBuckets(oldValue);
			const formattedNewBucket = renderBuckets(newValue);

			return {
				...data,
				oldValue: formattedOldBucket,
				newValue: formattedNewBucket
			};
		}
		return data;
	};
	return {
		abTestVersionHistoryFormatter,
		renderBuckets
	};
};
